module.exports = __webpack_public_path__ + "static/media/raven_sad_07.9bfdb289.svg";